// Catálogo espanhol: um arquivo por lote de tradução + base.ts (entradas curadas à mão).
// Regenerado por scripts/i18n/merge-catalog.mjs — não edite este arquivo à mão.
import base from './base';
import c_acessos_01 from './acessos-01';
import c_acessos_02 from './acessos-02';
import c_app_01 from './app-01';
import c_appart_01 from './appart-01';
import c_appart_02 from './appart-02';
import c_bloqueio_motivo_01 from './bloqueio-motivo-01';
import c_bolao_01 from './bolao-01';
import c_cards_home_4271 from './cards-home-4271';
import c_ciclo_vida_01 from './ciclo-vida-01';
import c_ciclo_vida_02 from './ciclo-vida-02';
import c_ciclo_vida_03 from './ciclo-vida-03';
import c_ciclo_vida_04 from './ciclo-vida-04';
import c_clientes_01 from './clientes-01';
import c_clube_01 from './clube-01';
import c_clube_02 from './clube-02';
import c_clube_03 from './clube-03';
import c_clube_cashback_01 from './clube-cashback-01';
import c_cobrancas_totais_01 from './cobrancas-totais-01';
import c_componentes_01 from './componentes-01';
import c_componentes_02 from './componentes-02';
import c_config_01 from './config-01';
import c_contrato_400_01 from './contrato-400-01';
import c_coupon_alert_multicanal_01 from './coupon-alert-multicanal-01';
import c_dashboards_01 from './dashboards-01';
import c_dashboards_02 from './dashboards-02';
import c_dashboards_03 from './dashboards-03';
import c_delta_01 from './delta-01';
import c_delta_02 from './delta-02';
import c_delta_03 from './delta-03';
import c_delta_04 from './delta-04';
import c_delta_05 from './delta-05';
import c_delta2_01 from './delta2-01';
import c_delta2_02 from './delta2-02';
import c_delta2_03 from './delta2-03';
import c_delta2_04 from './delta2-04';
import c_delta3_01 from './delta3-01';
import c_delta4_01 from './delta4-01';
import c_delta5_01 from './delta5-01';
import c_delta7_01 from './delta7-01';
import c_descontos_01 from './descontos-01';
import c_descontos_desativar_notificacao_01 from './descontos-desativar-notificacao-01';
import c_descontos_lista_02 from './descontos-lista-02';
import c_descontos_v2_01 from './descontos-v2-01';
import c_descontos_v2_02 from './descontos-v2-02';
import c_descontos_v2_03 from './descontos-v2-03';
import c_descontos_v2_04 from './descontos-v2-04';
import c_dev_requests_01 from './dev-requests-01';
import c_dev_requests_02 from './dev-requests-02';
import c_dev_requests_03 from './dev-requests-03';
import c_dev_requests_04 from './dev-requests-04';
import c_dispatch_alert_01 from './dispatch-alert-01';
import c_dispositivos_02 from './dispositivos-02';
import c_dr8_01 from './dr8-01';
import c_ecosystem_hub_01 from './ecosystem-hub-01';
import c_enums_01 from './enums-01';
import c_extrato_operacoes_01 from './extrato-operacoes-01';
import c_extrato_operacoes_02 from './extrato-operacoes-02';
import c_feature157_heatmap_ai_01 from './feature157-heatmap-ai-01';
import c_home_bloco_validade from './home-bloco-validade';
import c_home_editor_01 from './home-editor-01';
import c_home_editor_02 from './home-editor-02';
import c_home_editor_03 from './home-editor-03';
import c_home_editor_04 from './home-editor-04';
import c_home_editor_05 from './home-editor-05';
import c_home_editor_06 from './home-editor-06';
import c_home_editor_07 from './home-editor-07';
import c_home_mockup_01 from './home-mockup-01';
import c_home_videos_01 from './home-videos-01';
import c_menu_01 from './menu-01';
import c_menu_02 from './menu-02';
import c_meta_frentista_a2 from './meta-frentista-a2';
import c_meta_frentista_a3 from './meta-frentista-a3';
import c_meta_frentista_ia_a4 from './meta-frentista-ia-a4';
import c_meta_frentista_ia_a5 from './meta-frentista-ia-a5';
import c_meta_frentista_ia_a6 from './meta-frentista-ia-a6';
import c_meta_frentista_ia_a7 from './meta-frentista-ia-a7';
import c_meta_frentista_interno_01 from './meta-frentista-interno-01';
import c_meta_frentista_interno_02 from './meta-frentista-interno-02';
import c_meta_frentista_melhorias_01 from './meta-frentista-melhorias-01';
import c_observacoes_layout_01 from './observacoes-layout-01';
import c_outros_resources_01 from './outros-resources-01';
import c_outros_resources_02 from './outros-resources-02';
import c_outros_resources_03 from './outros-resources-03';
import c_outros_resources_04 from './outros-resources-04';
import c_outros_resources_05 from './outros-resources-05';
import c_painel360_asof_01 from './painel360-asof-01';
import c_parceiros_01 from './parceiros-01';
import c_pontuacoes_01 from './pontuacoes-01';
import c_postos_01 from './postos-01';
import c_produtos_01 from './produtos-01';
import c_recovery_ai_01 from './recovery-ai-01';
import c_recovery_bands_01 from './recovery-bands-01';
import c_recovery_brinde_01 from './recovery-brinde-01';
import c_recovery_gift_publico_01 from './recovery-gift-publico-01';
import c_recovery_notification_status from './recovery-notification-status';
import c_recovery_repaginacao_01 from './recovery-repaginacao-01';
import c_recovery_repaginacao_02 from './recovery-repaginacao-02';
import c_recovery_repaginacao_03 from './recovery-repaginacao-03';
import c_recovery_repaginacao_04 from './recovery-repaginacao-04';
import c_recovery_report_01 from './recovery-report-01';
import c_recuperacao_01 from './recuperacao-01';
import c_recuperacao_02 from './recuperacao-02';
import c_recuperacao_03 from './recuperacao-03';
import c_recuperacao_04 from './recuperacao-04';
import c_recuperacao_resultado_01 from './recuperacao-resultado-01';
import c_redes_01 from './redes-01';
import c_relatorios_01 from './relatorios-01';
import c_relatorios_02 from './relatorios-02';
import c_relatorios_03 from './relatorios-03';
import c_revendas_01 from './revendas-01';
import c_rfm_01 from './rfm-01';
import c_roleta_01 from './roleta-01';
import c_saldo_negativo_filtros_01 from './saldo-negativo-filtros-01';
import c_sale_products_cashback_01 from './sale-products-cashback-01';
import c_sislav_01 from './sislav-01';
import c_sorteio_01 from './sorteio-01';
import c_tag_clientes_01 from './tag-clientes-01';

// base por último: entrada curada à mão vence a gerada.
const catalog: Record<string, string> = {
    ...c_acessos_01,
    ...c_acessos_02,
    ...c_app_01,
    ...c_appart_01,
    ...c_appart_02,
    ...c_bloqueio_motivo_01,
    ...c_bolao_01,
    ...c_cards_home_4271,
    ...c_ciclo_vida_01,
    ...c_ciclo_vida_02,
    ...c_ciclo_vida_03,
    ...c_ciclo_vida_04,
    ...c_clientes_01,
    ...c_clube_01,
    ...c_clube_02,
    ...c_clube_03,
    ...c_clube_cashback_01,
    ...c_cobrancas_totais_01,
    ...c_componentes_01,
    ...c_componentes_02,
    ...c_config_01,
    ...c_contrato_400_01,
    ...c_coupon_alert_multicanal_01,
    ...c_dashboards_01,
    ...c_dashboards_02,
    ...c_dashboards_03,
    ...c_delta_01,
    ...c_delta_02,
    ...c_delta_03,
    ...c_delta_04,
    ...c_delta_05,
    ...c_delta2_01,
    ...c_delta2_02,
    ...c_delta2_03,
    ...c_delta2_04,
    ...c_delta3_01,
    ...c_delta4_01,
    ...c_delta5_01,
    ...c_delta7_01,
    ...c_descontos_01,
    ...c_descontos_desativar_notificacao_01,
    ...c_descontos_lista_02,
    ...c_descontos_v2_01,
    ...c_descontos_v2_02,
    ...c_descontos_v2_03,
    ...c_descontos_v2_04,
    ...c_dev_requests_01,
    ...c_dev_requests_02,
    ...c_dev_requests_03,
    ...c_dev_requests_04,
    ...c_dispatch_alert_01,
    ...c_dispositivos_02,
    ...c_dr8_01,
    ...c_ecosystem_hub_01,
    ...c_enums_01,
    ...c_extrato_operacoes_01,
    ...c_extrato_operacoes_02,
    ...c_feature157_heatmap_ai_01,
    ...c_home_bloco_validade,
    ...c_home_editor_01,
    ...c_home_editor_02,
    ...c_home_editor_03,
    ...c_home_editor_04,
    ...c_home_editor_05,
    ...c_home_editor_06,
    ...c_home_editor_07,
    ...c_home_mockup_01,
    ...c_home_videos_01,
    ...c_menu_01,
    ...c_menu_02,
    ...c_meta_frentista_a2,
    ...c_meta_frentista_a3,
    ...c_meta_frentista_ia_a4,
    ...c_meta_frentista_ia_a5,
    ...c_meta_frentista_ia_a6,
    ...c_meta_frentista_ia_a7,
    ...c_meta_frentista_interno_01,
    ...c_meta_frentista_interno_02,
    ...c_meta_frentista_melhorias_01,
    ...c_observacoes_layout_01,
    ...c_outros_resources_01,
    ...c_outros_resources_02,
    ...c_outros_resources_03,
    ...c_outros_resources_04,
    ...c_outros_resources_05,
    ...c_painel360_asof_01,
    ...c_parceiros_01,
    ...c_pontuacoes_01,
    ...c_postos_01,
    ...c_produtos_01,
    ...c_recovery_ai_01,
    ...c_recovery_bands_01,
    ...c_recovery_brinde_01,
    ...c_recovery_gift_publico_01,
    ...c_recovery_notification_status,
    ...c_recovery_repaginacao_01,
    ...c_recovery_repaginacao_02,
    ...c_recovery_repaginacao_03,
    ...c_recovery_repaginacao_04,
    ...c_recovery_report_01,
    ...c_recuperacao_01,
    ...c_recuperacao_02,
    ...c_recuperacao_03,
    ...c_recuperacao_04,
    ...c_recuperacao_resultado_01,
    ...c_redes_01,
    ...c_relatorios_01,
    ...c_relatorios_02,
    ...c_relatorios_03,
    ...c_revendas_01,
    ...c_rfm_01,
    ...c_roleta_01,
    ...c_saldo_negativo_filtros_01,
    ...c_sale_products_cashback_01,
    ...c_sislav_01,
    ...c_sorteio_01,
    ...c_tag_clientes_01,
    ...base,
};

export default catalog;
